import { render, staticRenderFns } from "./VPSFFSqaComponent.vue?vue&type=template&id=6ea1ce2c&scoped=true"
import script from "./VPSFFSqaComponent.vue?vue&type=script&lang=js"
export * from "./VPSFFSqaComponent.vue?vue&type=script&lang=js"
import style0 from "./VPSFFSqaComponent.vue?vue&type=style&index=0&id=6ea1ce2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea1ce2c",
  null
  
)

export default component.exports